import Vue from 'vue'
import Router from 'vue-router'
import UrlConstant from '../common/url-constant'
import CommonConstant from '../common/common-constant'

const DashboardLayout = () => import('@/layout/DashboardLayout')

const Integrations = () => import('@/pages/integrations/Integrations.vue')
const IntegrationDetails = () => import('@/pages/integration-details/IntegrationDetails.vue')
const Schedules = () => import('@/pages/schedules/Schedules.vue')
const Reports = () => import('@/pages/reports/Reports.vue')
const WorkloadReport = () => import('@/pages/workload-report/WorkloadReportLayout.vue')
const ProductivityReport = () => import('@/pages/productivity-report/ProductivityReportLayout.vue')
const UtilizationReport = () => import('@/pages/utilization-report/UtilizationReportLayout.vue')
const DoraReport = () => import('@/pages/dora-report/DoraReportLayout.vue')
const PersonalReport = () => import('@/pages/personal-report/PersonalReportLayout.vue')
const RulesConfig = () => import('@/pages/rules-config/RuleConfigLayout.vue')
const PullRequests = () => import('@/pages/pull-requests/PullRequest.vue')
const DeveloperComparison = () => import('@/pages/developer-comparison/DeveloperComparison.vue')

Vue.use(Router)

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: UrlConstant.page.HOME,
      name: UrlConstant.name.HOME,
      redirect: UrlConstant.page.INTEGRATIONS,
      component: DashboardLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: UrlConstant.page.REPORTS,
          name: UrlConstant.name.REPORTS,
          component: Reports,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.REPORTS,
                lang: 'overall_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.INTEGRATIONS,
          name: UrlConstant.name.INTEGRATIONS,
          component: Integrations,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.INTEGRATIONS,
                lang: 'integrations'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.INTEGRATION_DETAILS,
          name: UrlConstant.name.INTEGRATION_DETAILS,
          component: IntegrationDetails,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.INTEGRATIONS,
                lang: 'integrations'
              },
              {
                name: UrlConstant.name.INTEGRATION_DETAILS,
                lang: 'integration_details'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.PULL_REQUESTS,
          name: UrlConstant.name.PULL_REQUESTS,
          component: PullRequests,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.PULL_REQUESTS,
                lang: 'pull_requests'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.SCHEDULES_BY_TENANT_ID,
          name: UrlConstant.name.SCHEDULES_BY_TENANT_ID,
          component: Schedules,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.INTEGRATIONS,
                lang: 'integrations'
              },
              {
                name: UrlConstant.name.SCHEDULES_BY_TENANT_ID,
                lang: 'schedules'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.WORKLOAD_REPORT,
          name: UrlConstant.name.WORKLOAD_REPORT,
          component: WorkloadReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.WORKLOAD_REPORT,
                lang: 'workload_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.PRODUCTIVITY_REPORT,
          name: UrlConstant.name.PRODUCTIVITY_REPORT,
          component: ProductivityReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.PRODUCTIVITY_REPORT,
                lang: 'productivity_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.UTILIZATION_REPORT,
          name: UrlConstant.name.UTILIZATION_REPORT,
          component: UtilizationReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.UTILIZATION_REPORT,
                lang: 'utilization_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.DORA_REPORT,
          name: UrlConstant.name.DORA_REPORT,
          component: DoraReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.DORA_REPORT,
                lang: 'dora_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.PERSONAL_REPORT,
          name: UrlConstant.name.PERSONAL_REPORT,
          component: PersonalReport,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.PERSONAL_REPORT,
                lang: 'personal_report'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.RULES_CONFIG,
          name: UrlConstant.name.RULES_CONFIG,
          component: RulesConfig,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.INTEGRATIONS,
                lang: 'integrations'
              },
              {
                name: UrlConstant.name.RULES_CONFIG,
                lang: 'rules_config'
              }
            ]
          }
        },
        {
          path: UrlConstant.page.DEVELOPER_COMPARISON,
          name: UrlConstant.name.DEVELOPER_COMPARISON,
          component: DeveloperComparison,
          meta: {
            requiresAuth: true,
            breadcrumb: [
              {
                name: UrlConstant.name.DEVELOPER_COMPARISON,
                lang: 'developer_comparison'
              }
            ]
          }
        }
      ]
    },
    {
      path: '*',
      redirect: UrlConstant.page.INTEGRATIONS
    }
  ]
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.requiresAuth)
  const authed = router.app.$keycloak.authenticated
  if (authRequired && !authed) {
    const loginUrl = router.app.$keycloak.createLoginUrl()
    window.location.replace(loginUrl)
    return
  }
  if (authRequired && authed) {
    const roleGroup = router.app.$keycloak.tokenParsed['realm_access'].roles
    // handling role admin
    // if (roleGroup.includes(CommonConstant.KEYCLOAK_ROLES.ADMIN) && !to.path.includes(UrlConstant.page.USER_LIST)) {
    //   next(UrlConstant.page.USER_LIST)
    // }
    // handling role admin
    if (roleGroup.includes(CommonConstant.KEYCLOAK_ROLES.ADMIN) && !to.path.includes(UrlConstant.page.HOME)) {
      next(UrlConstant.page.HOME)
    }
    // Handling language
    if (from.query && to.query && from.query.lang === to.query.lang) {
      next()
    } else {
      if (from.query && from.query.lang && (!to.query || !to.query.lang)) {
        to.query.lang = from.query.lang
        next({name: to.name, path: to.path, params: to.params, query: to.query})
      } else {
        next()
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js